// The lockstep-synchronized LCG. game/misc.cpp:575-615.
//
// One Rng instance per role per SimContext: the SYNC rng (glSeed — must stay identical
// across all machines; seeded by ScBeginGame.ulRandomSeed, or the constant 0x29a in
// single-player) and the ASYNC rng (glAsyncSeed — local-only cosmetics, e.g. voice picks).
// Wiring an async call site to the sync instance (or vice versa) is a desync: the call-site
// inventory in tasks/sim-core-map.md is the authority (48 sync sites).

export class Rng {
  // game/misc.cpp:581 `static long glSeed = 1L;` (:610 glAsyncSeed likewise)
  private seed = 1;

  // game/misc.cpp:586-593 _GetRandom
  GetRandom(): number {
    // glSeed = glSeed * 214013L + 2531011L; return (glSeed >> 16) & 0x7fff
    this.seed = (Math.imul(this.seed, 214013) + 2531011) | 0;
    return (this.seed >> 16) & 0x7fff; // arithmetic >> — glSeed is signed long
  }

  // game/misc.cpp:595-598 SetRandomSeed — `glSeed = (long)nSeed`
  SetRandomSeed(nSeed: number): void {
    this.seed = nSeed | 0;
  }

  // game/misc.cpp:600-603 GetRandomSeed — returns unsigned long
  GetRandomSeed(): number {
    return this.seed >>> 0;
  }
}
